import React from 'react';
import { ITabItem } from 'components/tab';
import RMTabs from 'components/customComponents/Controls/RMTabs';
import ImagingSetting from '../ImagingSetting/ImagingSetting';
import ImagingSchedule from '../ImagingSchedule/ImagingSchedule';
import { useRMSelector } from 'redux/hooks';
import { IStyle } from 'Styles';
import {
  selectPlatesAtImagerStatus,
} from 'redux/selectors/StateSelectors';
import useRMLite from 'CustomHooks/useRMLite';
import { useLastSelectedWellNavigationDetails } from 'redux/hooks/experiment';

const tabComponents: ITabItem[] = [
  {
    title: 'Imaging Settings',
    eventKey: 'Image Settings',
    content: <ImagingSetting />,
  },
  {
    title: 'Imaging Schedule',
    eventKey: 'Image Schedule',
    content: <ImagingSchedule />,
  },
];
const ImageInfo = () => {
  const wellNavigationDetails = useLastSelectedWellNavigationDetails();
  const plateAtImagerStatus = useRMSelector((state) => selectPlatesAtImagerStatus(state));
  const rmLite = useRMLite();

  const isPlateAtImager = plateAtImagerStatus?.find(
    (item) => (item.plateId = wellNavigationDetails?.plateID),
  )?.isPlateAtImager;

  return (
    <div id={`commandpanel-expdashboardinfo-image-wrapper`} >
      {!isPlateAtImager && !rmLite && (
        <div id='commandpanel-expdashboardinfo-image-status`' style={styles.plateAtImagerStatus}>Plate Not in Imager</div>
      )}
      <div id={`commandpanel-expdashboardinfo-image-container`} className="container-fluid p-0" style={{ height: '75vh', overflow: 'auto' }}>
        {rmLite ? (
          <ImagingSchedule />
        ) : (
          <RMTabs
            tabItems={tabComponents}
            defaultActiveKey={'Image Settings'}
            id={'ImageTabs'}
          />
        )}
      </div>
    </div>
  );
};
const styles: IStyle = {
  plateAtImagerStatus: {
    color: 'red',
    marginLeft: '2%',
    marginTop: '1%',
  },
};
export default ImageInfo;
